// Epsom Blood Tests — Phlebotomy Fee Script
const PHLEBOTOMY_VARIANT_ID = 52480025952583;
const AT_HOME_VARIANT_ID = 53578091364679;
const COLLECTION_OPTION_NAME = 'Choose your collection method';
const INCLINIC_OPTION_VALUE = 'In-Clinic Blood Draw';
const AT_HOME_OPTION_VALUE = 'At-Home Phlebotomy Visit';

let isUpdating = false;
let backoffUntil = 0;

async function getCart() {
  const response = await fetch('/cart.js');
  return response.json();
}

async function addFee(variantId) {
  isUpdating = true;
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    const data = await response.json();
    if (response.status === 429) {
      console.log('EBT — rate limited, backing off 60 seconds');
      backoffUntil = Date.now() + 60000;
      return;
    }
    if (response.status >= 400) {
      console.log('EBT — add failed, backing off 30 seconds:', data.message);
      backoffUntil = Date.now() + 30000;
      return;
    }
    console.log('EBT — fee added:', variantId);
    setTimeout(refreshCart, 500);
  } catch(e) {
    console.error('EBT — error adding fee:', e);
    backoffUntil = Date.now() + 30000;
  } finally {
    isUpdating = false;
  }
}

async function removeFee(cartItemKey) {
  isUpdating = true;
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: cartItemKey, quantity: 0 })
    });
    console.log('EBT — fee removed');
    setTimeout(refreshCart, 500);
  } catch(e) {
    console.error('EBT — error removing fee:', e);
  } finally {
    isUpdating = false;
  }
}

function refreshCart() {
  fetch('/?sections=cart-drawer')
    .then(r => r.json())
    .then(sections => {
      if (!sections['cart-drawer']) return;
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

      const newItems = doc.querySelector('#CartDrawer-CartItems');
      const existingItems = document.querySelector('#CartDrawer-CartItems');
      if (newItems && existingItems) {
        existingItems.innerHTML = newItems.innerHTML;
      }

      const newFooter = doc.querySelector('.drawer__footer');
      const existingFooter = document.querySelector('.drawer__footer');
      if (newFooter && existingFooter) {
        existingFooter.innerHTML = newFooter.innerHTML;
      }

      console.log('EBT — drawer refreshed');
    })
    .catch(e => console.error('EBT — refresh error:', e));
}

async function checkAndUpdatePhlebotomyFee() {
  if (isUpdating) return;
  if (Date.now() < backoffUntil) {
    console.log('EBT — in backoff, skipping check');
    return;
  }

  try {
    const cart = await getCart();
    const items = cart.items;

    // Check for in-clinic tests
    const hasInClinicTest = items.some(item => {
      if (item.variant_id === PHLEBOTOMY_VARIANT_ID) return false;
      if (item.variant_id === AT_HOME_VARIANT_ID) return false;
      return item.options_with_values && item.options_with_values.some(o =>
        o.name === COLLECTION_OPTION_NAME && o.value === INCLINIC_OPTION_VALUE
      );
    });

    // Check for at-home tests
    const hasAtHomeTest = items.some(item => {
      if (item.variant_id === PHLEBOTOMY_VARIANT_ID) return false;
      if (item.variant_id === AT_HOME_VARIANT_ID) return false;
      return item.options_with_values && item.options_with_values.some(o =>
        o.name === COLLECTION_OPTION_NAME && o.value === AT_HOME_OPTION_VALUE
      );
    });

    const inClinicFeeItem = items.find(item => item.variant_id === PHLEBOTOMY_VARIANT_ID);
    const atHomeFeeItem = items.find(item => item.variant_id === AT_HOME_VARIANT_ID);

    console.log('EBT Check — hasInClinic:', hasInClinicTest, '| hasAtHome:', hasAtHomeTest, '| inClinicFee:', !!inClinicFeeItem, '| atHomeFee:', !!atHomeFeeItem);

    // Handle in-clinic fee
    if (hasInClinicTest && !inClinicFeeItem) {
      await addFee(PHLEBOTOMY_VARIANT_ID);
    } else if (!hasInClinicTest && inClinicFeeItem) {
      await removeFee(inClinicFeeItem.key);
    }

    // Handle at-home fee
    if (hasAtHomeTest && !atHomeFeeItem) {
      await addFee(AT_HOME_VARIANT_ID);
    } else if (!hasAtHomeTest && atHomeFeeItem) {
      await removeFee(atHomeFeeItem.key);
    }

  } catch(e) {
    console.error('EBT — check error:', e);
  }
}

// Watch for cart drawer opening
const drawerObserver = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    if (mutation.attributeName === 'class') {
      const drawer = mutation.target;
      if (drawer.classList.contains('active')) {
        console.log('EBT — drawer opened, checking fee');
        setTimeout(checkAndUpdatePhlebotomyFee, 0);
      }
    }
  });
});

// Remove button clicks
document.addEventListener('click', function(e) {
  if (
    e.target.matches('.cart-remove-button') ||
    e.target.closest('.cart-remove-button') ||
    e.target.closest('cart-remove-button')
  ) {
    setTimeout(checkAndUpdatePhlebotomyFee, 1000);
  }
});

// Quantity changes
document.addEventListener('change', function(e) {
  if (e.target.matches('.quantity__input')) {
    setTimeout(checkAndUpdatePhlebotomyFee, 1500);
  }
});

// Fallback poll every 10 seconds
setInterval(checkAndUpdatePhlebotomyFee, 10000);

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  checkAndUpdatePhlebotomyFee();
});